module.exports = __webpack_public_path__ + "assets/img/icon-satellite-gray.2ad0a3bc.png";